// extracted by mini-css-extract-plugin
export default {"addButton":"CurrentJobsScreen_admin_addButton__WT8YV"};